import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';

import MobileCarousel from 'widget/components/mobile-carousel/mobile-carousel';
import firstTimeTrackAnimation from 'widget/components/first-time-track-animation/first-time-track-animation';
import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { getCurrentSiteUser } from 'widget/selectors/current-site-user';
import { isExternalVideo } from 'shared/ui-selectors/video/video-origin';

import fetchVideoUrls from 'widget/redux/client/actions/video-urls/fetch';


// TODO: separate lazy load logic. Separate fetching urls for next video.
/*
 This component is performance dependable. Please avoid @ui because it leads to extra render while swiping
 */
@connect(
  state => ({
    videoIds: state.lazyVideoLists.mobileWidget.videoIds,
    videoByIds: getVideosGroupedByIds(state),
    currentSiteUser: getCurrentSiteUser(state),
  }),
  {
    fetchVideoUrls,
  })
@firstTimeTrackAnimation
export default class SlidableListWithLazyLoad extends React.Component {

  static propTypes = {
    videoIds: React.PropTypes.array,
    videoByIds: React.PropTypes.object,
    onUserStartedTracking: React.PropTypes.func,
    className: React.PropTypes.string,
    trackClassName: React.PropTypes.string,
    currentSiteUser: React.PropTypes.object,

    loadMore: React.PropTypes.func,
    itemHeight: React.PropTypes.number,
    onCurrentSlideChanged: React.PropTypes.func,
    fetchVideoUrls: React.PropTypes.func,
    selectedVideoId: React.PropTypes.string,
    children: React.PropTypes.arrayOf(React.PropTypes.element),
  };

  static defaultProps = {
    onCurrentSlideChanged: _.noop,
  };

  nextVideo(currentIndex) {
    const { videoIds, videoByIds } = this.props;

    if (_.size(videoIds) > currentIndex + 1) {
      const nextIndex = videoIds[currentIndex];
      return videoByIds[nextIndex];
    }

    return null;
  }

  fetchUrlsForNextVideo(currentVideoIndex) {
    const { fetchVideoUrls, currentSiteUser } = this.props;
    const nextVideo = this.nextVideo(currentVideoIndex);

    if (nextVideo) {
      if (!isExternalVideo(nextVideo)) {
        if (!nextVideo.memberOnly || currentSiteUser) {
          fetchVideoUrls(nextVideo);
        }
      }
    }
  }

  @autobind
  @debounce(50)
  afterChange(leftVisibleSlideIndex) {
    const { loadMore, onCurrentSlideChanged } = this.props;
    const slidesShown = leftVisibleSlideIndex + 3;

    loadMore(slidesShown);
    this.fetchUrlsForNextVideo(leftVisibleSlideIndex);
    onCurrentSlideChanged(leftVisibleSlideIndex);
  }

  get selectedIndex() {
    const { videoIds, selectedVideoId } = this.props;

    const selectedVideoIndex = _.indexOf(videoIds, selectedVideoId);
    return selectedVideoIndex < 0 ? 0 : selectedVideoIndex;
  }

  render() {
    const { className, itemHeight, trackClassName, onUserStartedTracking, children } = this.props;

    return (
      <MobileCarousel afterChange={this.afterChange}
                      getHeight={_.constant(itemHeight)}
                      showButtons={false}
                      onUserStartedTracking={onUserStartedTracking}
                      slidesToShow={1}
                      trackClassName={trackClassName}
                      className={className}
                      initialSlide={this.selectedIndex}>
        {children}
      </MobileCarousel>
    );
  }
}




// WEBPACK FOOTER //
// ./src/widget/components/slidable-list-with-lazy-load/slidable-list-with-lazy-load.js